module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n      Dashboard content\n    ")]), _vm._v(" "), (_vm.menu) ? _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.name,
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "item": item,
        "to": {
          path: ("" + (item.url))
        }
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" " + _vm._s(item.name) + "\n        ")])
  }), 1)]) : _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n      Content is empty for current user.\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbc34dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 889
// module chunks = 0